import Integrations_Runs_AdminManageRunsPage from "@Integrations/Runs/Pages/AdminManageRunsPage.vue";
import Integrations_Runs_AdminRunDetailsPage from "@Integrations/Runs/Pages/AdminRunDetailsPage.vue";

export const routes = [
    // admin pages
    {
        path: "/admin/integrations/runs/manage/:tid/",
        component: Integrations_Runs_AdminManageRunsPage
    },
    {
        path: "/admin/integrations/runs/details/:tid/:id",
        component: Integrations_Runs_AdminRunDetailsPage
    },
]
